<!-- Header-less screens from the design: login, prepayment, deal detail, buy flow -->
<template>
  <main id="main" class="bare">
    <slot />
  </main>
</template>

<style scoped>
.bare {
  min-height: 100vh;
  background: var(--gray-50);
}
</style>
